import {Mapper} from '@s-ui/domain'

import {UserConsentsStatusUserValueObject} from '../ValueObjects/UserConsentsStatusUserValueObject.js'
import {UserConsentUserValueObject} from '../ValueObjects/UserConsentUserValueObject.js'

export class FromHttpGetConsentsResponseToUserConsentsStatusUserValueObjectMapper extends Mapper {
  static create() {
    return new FromHttpGetConsentsResponseToUserConsentsStatusUserValueObjectMapper()
  }

  map = (getConsentsResponse = {}) => {
    const consentsKeys = Object.keys(getConsentsResponse)

    const consents = consentsKeys.map(key => {
      return UserConsentUserValueObject.create({
        key,
        status: getConsentsResponse[key]
      })
    })

    return UserConsentsStatusUserValueObject.create({consents})
  }
}
